<template>
  <div class="online-course-wrap">
    <div class="main">
      <div class="main-loading-modify">
        <div v-show="active2 === 0" class="content-wrap">
          <div
            v-show="!video.list.length > 0 && isShowVideo"
            class="placeholer-wrap"
          >
            <!-- <video 
                 class="video" 
                 autoplay 
                 x5-playsinline="true"
                 playsinline
                 webkit-playsinline="true"
                 controlsList="nodownload"
                 controls
                 src="http://video.yocent.cn/2c694c394b82419d96ef597794af36bd/e0cfb216bd5247c187bbcec65f806e1e-8511f34fa5421b0019695c474e4971e8-ld.mp4"></video> -->
          </div>
          <video
            v-show="isShowVideo"
            ref="video"
            :src="video.info.PlayURL"
            :poster="video.info.cover"
            webkit-playsinline="true"
            class="video"
            x5-playsinline="true"
            playsinline
            controlsList="nodownload noplaybackrate"
            preload="auto"
            controls
          >
            不支持 video 标签
          </video>
        </div>

        <div v-show="active2 === 1" class="content-wrap text-center">
          <div
            v-show="!audio.list.length > 0"
            class="placeholer-wrap text-center"
          >
            <!-- <img src="../assets/Q2.jpg"
                 class="img"> -->
            <!-- <h2 class="audio-title ">可能否-木小雅</h2>
            <audio src="可能否-木小雅-可能否.mp3" controlsList="nodownload" class="audio" controls></audio> -->
          </div>
          <h2 class="audio-title">{{ audio.info.title }}</h2>
          <audio
            ref="audio"
            :src="audio.info.PlayURL"
            class="audio"
            controlsList="nodownload"
            controls
          >
            不支持 audio 标签
          </audio>
        </div>

        <div v-show="active2 === 2" class="content-wrap">
          <!-- <img src="../assets/Q2.jpg" 
               class="img"> -->
        </div>
      </div>

      <mu-tabs
        :value.sync="active2"
        color="#242424"
        text-color="#e6e6e6"
        indicator-color="#214ecf"
        full-width
      >
        <mu-tab>视频</mu-tab>
        <mu-tab>音频</mu-tab>
        <mu-tab>课件</mu-tab>
      </mu-tabs>

      <mu-container class="resource-list-wrap">
        <mu-flex class="flex-wrapper" justify-content="between">
          <mu-flex class="flex-demo" justify-content="start">
            <h2 class="chapter-title">{{ title }}</h2>
          </mu-flex>

          <mu-flex class="flex-demo" justify-content="end"></mu-flex>
        </mu-flex>
        <div v-show="active2 === 0" class="demo-text">
          <resource-list
            :is-record="isRecord"
            :complete-first="video.config.completeFirst"
            :list="video.list"
            :type="0"
            :current-index="currentVedioIndex"
            icon-value="play_circle_outline"
            @getData="setCurrentVideoInfo"
          />
        </div>
        <div v-show="active2 === 1" class="demo-text">
          <resource-list
            :complete-first="audio.config.completeFirst"
            :list="audio.list"
            :type="1"
            icon-value="music_note"
            @getData="setCurrentAudioInfo"
          />
        </div>
        <div v-show="active2 === 2" class="demo-text">
          <resource-list
            :list="picture.list"
            :type="2"
            icon-value="filter"
            @getData="setCurrentPictureInfo"
            @repeatClick="setSwiper"
          />

          <mu-dialog
            :open.sync="openFullscreen"
            :padding="12"
            :scrollable="true"
            class="test-dialog-style"
            width="360"
            transition="slide-bottom"
            fullscreen
          >
            <mu-appbar
              :title="picture.info.title"
              class="fixed-top"
              color="#214ecf"
            >
              <mu-button slot="right" icon @click="closeFullscreenDialog">
                <mu-icon value="close" />
              </mu-button>
            </mu-appbar>

            <div class="dialog-content">
              <div class="swiper-active-content">
                <img
                  id="swiperImg"
                  ref="swiperImg"
                  :src="picture.swiper.activeImgUrl"
                />
              </div>

              <div class="swiper-container swiper-custom gallery-thumbs">
                <div class="swiper-wrapper swiper-custom-nav">
                  <div
                    v-for="(item, key) in picture.info.content"
                    :key="key"
                    :class="{
                      active: key === picture.swiper.activeIndex,
                      disabled: view_all === 0,
                    }"
                    class="swiper-custom-nav-item swiper-slide f0"
                    @click="setPictureSlideTo(key, item.image, view_all === 0)"
                  >
                    <img :src="item.image" class="swiper-img" />
                    <span class="number">{{ key + 1 }}</span>
                  </div>
                </div>
                <div class="swiper-pagination" />
              </div>
            </div>
          </mu-dialog>
        </div>
      </mu-container>
    </div>
  </div>
</template>

<script>
import {
  fetchCourseChapterDetails,
  fetchCourseChapterDetailsRecordCourse,
} from '@/api/index'
// import { secToDate } from '@/utils/utils.js'
import ResourceList from '@/components/ResourceList.vue'
import Swiper from 'swiper/dist/js/swiper.js'
import PinchZoom from 'pinch-zoom-js'

export default {
  components: {
    ResourceList,
  },
  data() {
    return {
      title: null,
      isRecord: this.$route.query.is_record == 'record', // 是否是观看记录
      chapterId: this.$route.query.chapter_id,
      isShowVideo: !this.$route.query.is_record,
      openFullscreen: false,
      active2: 0,
      view_all: 0,
      isFirstIn: true,
      currentVedioIndex: 0,
      video: {
        info: {},
        list: [],
        config: {
          element: null,
          completeFirst: false,
        },
      },
      audio: {
        info: {},
        list: [],
        config: {
          element: null,
          completeFirst: false,
        },
      },
      picture: {
        info: {},
        list: [],
        swiper: {
          activeIndex: 0,
          activeImgUrl: '',
        },
        config: {
          element: null,
        },
      },

      info: {
        name: null,
        activeIndex: 0,
      },
    }
  },

  computed: {
    isVisible() {
      const r = +this.$route.query.is_visible === 1
      return r
    },
    allowPrctise() {
      const r = +this.$route.query.allow_practise === 1
      return r
    },
  },

  watch: {
    active2(val, oldVal) {
      if (val === 1 || this.audio.config.completeFirst === false) {
        this.audio.config.completeFirst = true
      }
      switch (oldVal) {
        case 0:
          if (this.$refs.video) this.$refs.video.pause()
          break

        case 1:
          if (this.$refs.audio) this.$refs.audio.pause()
          break
      }
    },
  },

  async mounted() {
    const params = {
      chapter_id: this.$route.query.chapter_id,
    }
    const details = await fetchCourseChapterDetails(params)
    this.title = details.title

    function format(arr) {
      const temp = arr.map((ele) => {
        if (ele.content && ele.material_content) {
          ele.content = JSON.parse(ele.content)
          ele.material_content = JSON.parse(ele.material_content)
        }
        return ele
      })
      return temp
    }

    const _v = details.video_lists.map((item) => {
      if (item.content && item.material_content) {
        item.content = JSON.parse(item.content)
        item.material_content = JSON.parse(item.material_content)
        if (item.curr_time >= parseInt(item.content.Duration)) {
          item.percent = '100%'
          item.is_finish = true
        } else {
          item.percent =
            ((item.curr_time * 100) / item.content.Duration).toFixed(1) + '%'
          item.is_finish = false
        }
      }
      return item
    })
    const _a = details.audio_lists
    const _c = details.course_ware_lists
    if (_v.length === 0 && _a.length === 0 && _c.length === 0) {
      this.$NewToast.info('暂无课程数据')
      return
    }

    ;[this.video.list, this.audio.list, this.picture.list] = [
      _v,
      format(_a),
      format(_c),
    ]

    this.$setHtmlTitle(this.title)

    this.MediaEventCenter(this.$refs.video, 'video')
    this.MediaEventCenter(this.$refs.audio, 'audio')
    this.video.config.completeFirst = true
  },

  methods: {
    MediaEventCenter(ele, type) {
      const self = this
      const msg = type === 'audio' ? '听' : '看'
      ele.addEventListener('canplaythrough', () => {
        // console.log('canplaythrough', ele);
        // ele.play();
        this.isFirstIn ? (this.isFirstIn = false) : ele.play()
      })

      let endeding = false
      ele.addEventListener('ended', () => {
        if (this[type].info.view_all === 0 && !endeding) {
          endeding = true
          this.$confirm(`试${msg}已结束，报名后收${msg}全部内容`, '提示', {
            okLabel: '去报名',
          }).then(({ result }) => {
            endeding = false
            if (result) {
              window.location = this.$root.$data.REGISTRATION_URL
            }
          })
        }
        if (this[type].info.view_all === 1) {
          this.rememberCurrentTime(
            type,
            this[type].info.id,
            ~~ele.currentTime,
            true
          )
          this[type].list[this.currentVedioIndex].percent = '100%'
          // 切换到下一个视频
          if (this.currentVedioIndex <= this.video.list.length - 1) {
            this.currentVedioIndex += 1
          }
        }
      })

      ele.addEventListener('timeupdate', function timupFun() {
        // console.log('The currentTime attribute has been updated. Again.')
        if (self[type].info.view_all === 0) {
          ele.addEventListener('timeupdate', timupFun)
          return false
        }
        // console.log('disableRemember', self[type].info.disableRemember)
        if (!self[type].info.disableRemember) {
          self[type].info.disableRemember = true
          self.rememberCurrentTime(type, self[type].info.id, ~~ele.currentTime)
        }
      })

      // https://developer.mozilla.org/en-US/docs/Web/API/MediaError
      // https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/error
      ele.addEventListener('error', (target) => {
        try {
          const msg =
            'Error ' + target.error.code + '; details: ' + target.error.message
          throw new Error(msg)
        } catch (e) {
          this.$NewToast.error('资源加载出错: ', e)
        }
      })
    },

    rememberCurrentTime(type, course_id, time) {
      // 缓存一份
      // let mediaHistory = JSON.parse(localStorage.getItem("mediaHistory")) || {};
      // mediaHistory[type] = mediaHistory[type] || {};
      // if (ended) {
      //   delete mediaHistory[type][course_id];
      // } else {
      //   mediaHistory[type][course_id] = time;
      // }
      // localStorage.setItem("mediaHistory", JSON.stringify(mediaHistory));
      // 服务器一份
      fetchCourseChapterDetailsRecordCourse({
        chapter_id: this.$route.query.chapter_id,
        course_id: course_id,
        curr_time: time,
      })
      // 间隔 20s 存一次
      setTimeout(() => (this[type].info.disableRemember = false), 30000)
    },

    setInfo(type, info, msg) {
      this.currentVedioIndex = info.index || 0
      let temp
      let ele = this[type]
      if (info.view_all === 1) {
        temp = info.content
      } else {
        temp = info.material_content
      }
      const par1 = {
        title: info.title,
        cover: info.cover,
        view_all: info.view_all,
        id: info.id,
      }

      console.log(temp, temp.PlayURL)
      if (!temp || !temp.PlayURL) {
        ele.info = { ...par1 }
        this.$NewToast.error(msg)
        return false
      }
      ele.info = { ...temp, ...par1 }

      // let mediaHistory = JSON.parse(localStorage.getItem("mediaHistory")) || {};
      // if (!mediaHistory[type]) return false;
      // const time = mediaHistory[type][info.id];
      // if (time) {
      //   this.$confirm(`上一次进行到${secToDate(time)}, 是否继续？`, "提示", {
      //     type: "info",
      //     okLabel: "继续",
      //     cancelLabel: "取消"
      //   }).then(({ result }) => {
      //     if (result) {
      //       this.$refs[type].currentTime = time;
      //     }
      //   });
      // }
    },

    setCurrentAudioInfo(info) {
      this.setInfo('audio', info, '无法播放音频')
    },

    setCurrentVideoInfo(info) {
      // if (this.isRecord) {
      // 观看记录
      if (info.curr_time >= parseInt(info.content.Duration)) {
        // 播放完成
        // this.$confirm(`该课程已完成学习`, '提示', {
        //   okLabel: '确认',
        // })
        this.isShowVideo = true
        this.setInfo('video', info, '无法播放视频')
        this.$refs.video.currentTime = 0
      } else {
        this.isShowVideo = true
        this.setInfo('video', info, '无法播放视频')
        this.$refs.video.currentTime = info.curr_time
      }
      // return
      // }
      this.setInfo('video', info, '无法播放视频')
    },

    setCurrentPictureInfo(info) {
      info.content = JSON.parse(info.content)
      this.picture.info = info

      this.setSwiper()
    },
    setSwiper() {
      this.openFullscreenDialog()
      this.$nextTick(function () {
        this.picture.config.element = new Swiper('.swiper-custom', {
          slidesPerView: 'auto',
          spaceBetween: 10,
          freeMode: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'custom',
          },
        })
        // this.picture.config.element = this.$refs.picture

        new PinchZoom(this.$refs.swiperImg, {})
        console.log(this.picture.config.element)
        this.setPictureSlideTo(
          0,
          this.picture.config.element.slides[0]
            .getElementsByClassName('swiper-img')[0]
            .getAttribute('src')
        )
        // this.setPictureSlideTo(
        //   0,
        //   document.getElementsByClassName("swiper-img")[0].getAttribute("src")
        // );
      })
    },
    setPictureSlideTo(index, imgUrl, failed) {
      if (failed && index >= 2) {
        this.$confirm(`非学员仅可试看前2张，报名后查看全部内容`, '提示', {
          okLabel: '去报名',
        }).then(({ result }) => {
          if (result) {
            window.location = this.$root.$data.REGISTRATION_URL
          }
        })
        return
      }
      this.picture.swiper.activeImgUrl = imgUrl
      this.picture.swiper.activeIndex = index
    },
    openFullscreenDialog() {
      this.openFullscreen = true
    },
    closeFullscreenDialog() {
      this.openFullscreen = false
    },
  },
}
</script>

<style lang="scss" scoped>
.audio {
  border-radius: 5px;
}
.audio-title {
  color: #fefefe;
}
.main-loading-modify {
  position: relative;
}
.mu-paper {
  background-color: #f3f5f7;
}

.flex-wrapper {
  padding-top: 30px;
}
.menu-item {
  color: #b0b0b0;
}
.swiper-container {
  width: 100%;
  height: 300px;
  margin-right: auto;
  margin-bottom: 15px;
  margin-left: auto;
}
.swiper-slide {
  display: inline-block;

  height: 100%;
  margin-right: 10px;

  background-position: center;
  background-size: cover;

  &:first-child {
    margin-left: 10px;
  }
}
.gallery-top {
  width: 100%;
  height: auto;
}
.gallery-thumbs {
  position: fixed;
  bottom: 0;
  bottom: 0;

  // overflow-x: scroll;

  min-width: 99%;
  height: 120px;
  margin-top: 8px;
  padding: 15px 0;

  font-size: 0;
  // white-space: nowrap;

  background-color: rgba(0, 0, 0, 0.4);

  // -webkit-overflow-scrolling: touch;

  .disabled:nth-child(n + 3) {
    filter: blur(2px);

    // &::before {
    //   font-size: 30px;

    //   position: absolute;
    //   top: 22px;
    //   left: 15px;

    //   content: "暂不支持";
    //   transform: rotate(0.05turn);

    //   color: #fff;
    //   background-color: rgba(255, 255, 255, 0.7);
    // }
  }
  .swiper-slide {
    width: 160px;
    height: 100%;

    opacity: 0.4;
  }

  .swiper-custom-nav-item {
    position: relative;

    height: 100%;

    .number {
      font-size: 16px;
      line-height: 24px + 2px;

      position: absolute;
      right: 0;
      bottom: 0;

      display: block;

      min-width: 24px;
      height: 24px;

      text-align: center;

      color: #fff;
      background-color: #aaa;
    }
  }
  .swiper-custom-nav-item.active {
    opacity: 1;
  }
}
.swiper-img {
  width: 100%;
  height: 100%;
}
.swiper-active-content {
  width: 96vw;
  height: 74%;
  margin: auto;

  img {
    max-width: 100%;
  }
}
.swiper-custom-nav {
  width: 100%;
  height: 100%;

  white-space: nowrap;
}
</style>

<style lang="scss">
// <link rel="stylesheet" href="//g.alicdn.com/de/prismplayer/2.7.2/skins/default/aliplayer-min.css" />
// @import url(@/lib/aliplayer/aliplayer-min.css);

.practice_btn {
  font-size: 12px;
  line-height: 28px;

  position: relative;
  top: 4px;

  height: 28px;

  .mu-button-wrapper {
    padding: {
      right: 10px;
      left: 10px;
    }
  }
  &.disable {
    color: #bbb;

    filter: grayscale(100%);
  }
}
.resource-list-wrap {
  overflow-y: scroll;

  width: 100%;
  height: calc(100vh - 56px - #{$VideoHeight});

  color: #71777d;

  -webkit-overflow-scrolling: touch;
  .chapter-title {
    margin: {
      top: 5px;
      bottom: 0;
    }
    padding: {
      left: 5px;
    }
    color: #555;
  }
}
.online-course-wrap {
  height: 100%;
  padding-bottom: 56px;

  .mu-tab-active {
    .mu-tab-wrapper {
      font-weight: bold;

      color: $MainColor;
    }
  }
}

.content-wrap {
  overflow: hidden;

  width: 100%;
  height: $VideoHeight;

  background: #726969;
  background: url(../assets/Q2.jpg) no-repeat;
  background-size: cover;

  .video {
    width: 100%;
    height: 100%;
  }
  .img {
    width: 100%;
    height: auto;
  }
}

.placeholer-wrap {
  overflow: hidden;

  width: 100%;
  height: 100%;

  background-color: rgba(0, 0, 0, 0.4);
}

.test-dialog-style {
  .mu-dialog-body {
    height: 100% !important;
    max-height: 100% !important;

    background-color: #595d60;
  }
  .dialog-content {
    font-size: 14px;

    position: relative;

    overflow-y: scroll;

    height: calc(100% - 76px);
    margin-top: 6px;
    padding: 0;

    color: #000;

    -webkit-overflow-scrolling: touch;
    .pinch-zoom-container {
      height: 100%;
    }
  }
}
</style>
